/* ── SmartPack Core ── */
(function () {
  'use strict';

  if (!window.SPCore) return;

  SPCore.DOMready(function () {
    document.querySelectorAll('[data-sp-product]').forEach(init);
  });

  function init(root) {
    if (root.spProductBound) return;
    root.spProductBound = true;
    initMedia(root);
  }

  /* ── Media ── */
  function initMedia(root) {
    var media = root.querySelector('[data-sp-media]');
    if (!media) return;

    media.querySelectorAll('[data-sp-media-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(media, thumb.dataset.spMediaThumb);
      });
    });
  }

  function showMedia(media, id) {
    media.querySelectorAll('[data-sp-media-slide]').forEach(function (slide) {
      slide.classList.toggle('is-active', slide.dataset.spMediaSlide === id);
    });
    media.querySelectorAll('[data-sp-media-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-current', String(thumb.dataset.spMediaThumb === id));
    });
  }
})();
